import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import CustomStore from 'devextreme/data/custom_store';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.scss']
})
export class ChangeStatusComponent extends SuperComponent implements OnInit {

  changeStatusForm:any= {};
  
  employeeMenu:any= [];
workvalue: any[] = [];          // المختارين بس
selectedRoles: any[] = [];   
  rolelist: any = []
  
  roleDataSource:any=[];
  branchesdropdown: [] =[];
  jobTitleDropDown: [] =[];
  bankDropDown: [] =[];
  departmentDropDown: [] =[];
  managementDropDown: [] =[];
  accountDropDown: [] =[];
  currentuser: [] =[]
  workSystemdropdown: [] =[]
  UserDropDown:{}[]=[]

    AttacmentMenu: any = [];

  employeeAttachments:{}[] = [];
  RoleColumn=  [{
    dataField: 'nameAr',    
    caption: this.translate.instant('tableinfo.NameAr'),
  }]

  employeeWorkStatusMenu: [] =[];

  status_id:any;
  customDataSource: any[];

  constructor(Objects: ObjectsService, translate: TranslateService,private location:Location,private router:Router,private EmployeeService:EmployeeService ,private publicSetting: publicSettingService, private NotifyService: NotifyService, gt: genericCustomStoreService) {
    super(Objects, translate, gt)
    this.getIDFromSubject();
     
  }

  buttonOptions = {
    text: this.translate.instant('employeeduration.submit'),
    type: 'default',
    useSubmitBehavior: true,
  };

  sendoptions = {

    text: this.translate.instant('publicsettingnav.sendtomail'),
    type: 'success',
    onClick: () => {
      this.onSendClick();
    }
  }
  contractoptions = {

    text: this.translate.instant('publicsettingnav.printcontract'),
    type: 'success',
    onClick: () => {
      this.printcontract();
    }
  }

  onSendClick(){
debugger
    const id = this.changeStatusForm.id;
    this.gt.$Ids.next([id])
   


    const url = this.router.serializeUrl(this.router.createUrlTree([`/print-report`, encodeURIComponent('rpt_EmployeesInformations')]));
   // console.log(url)
   // window.open(url, '_blank');
   this.router.navigate([url]);

  }
  onRolesChanged(e: any) {
    this.workvalue = e.selectedRowKeys;   // المختارين بس
}

  printcontract(){
   debugger
    const id = this.changeStatusForm.id;
    this.gt.$Ids.next(id)
   


    const url = this.router.serializeUrl(this.router.createUrlTree([`/print-report`, encodeURIComponent('rpt_contract')]));
   // console.log(url)
   // window.open(url, '_blank');
   this.router.navigate([url]);

  }
  ngOnInit(): void {
    this.getAllEmployeeMenu();
    this.getEmployeeWorkStatusDropDown();
    this.getDataById();
    this.getbranchdropdown();
    this.getAllJobTitledDropDown();
    this.getAllbankDropDown();
    this.getAlldepartmentDropDown();
    this.getAllmanagementDropDown();
    this.getAllAccountsDropDown();
    this.getUserDroDown();
   this.getallattachment();
   this.getEmployeeAttachmentMenu()

    this.gt.getdropdowndata("Role").subscribe((res) => {

      this.rolelist =this.mapingRoleData(res);
      this.roleDataSource=this.makeAsyncRoles()

      console.log(this.roleDataSource)
      console.log(this.roleDataSource)
    })
        this.gt.getdropdowndata("WorkSystem").subscribe((res: []) => this.workSystemdropdown = res)

  }

  mapingRoleData(data: any) {
    let newArray = data?.map((item :any)=> {
      return {
        id: item?.id,
        nameAr: item?.name,
        nameEn: item?.name,
      };
    });
    return newArray;
  }

  onEditingStart(e: any) {
    this.addpopup = this.translate.instant('hr.EmployeeStatus');
  }
  getEmployeeWorkStatusDropDown() {
    this.gt.getdropdowndata('Employee/GetDropDown', 'EmployeeWorkStatus').subscribe((res: any) => {
      this.employeeWorkStatusMenu = res;
      console.log("work", this.employeeWorkStatusMenu)
    })
  }
  getAllEmployeeMenu () {
    this.gt.getdropdown('Employee').subscribe((res:any)=> {
      this.employeeMenu = res;
      console.log("this.employeeMenu", this.employeeMenu)
    })
  }
    getallattachment () {

    this.gt.getdropdown('EmployeeAttachment').subscribe((res:any)=> {
      console.log("this.employeeMenu", res)
      console.log("this.employeeMenu", this.changeStatusForm.id)
      const filteredAttachments = res.filter((a:any) => a.employeeId === this.changeStatusForm.id)
      this.employeeAttachments = filteredAttachments;

   
    })
  }
fixPath(url: string): string {
  return url.replace(/\\/g, '/');
}


  getIDFromSubject() {
    this.EmployeeService.$Status_ID.subscribe((res:any)=> {
      this.status_id = res.id;
      console.log("res id",res.id)
            console.log("res ",res)
     

    })
  }


  getDataById () {
   if(this.status_id == undefined || this.status_id == null){
    return;
   }
    this.publicSetting.byKey('ChangeEmployeeStatus', this.status_id).subscribe((res:any)=>{
      this.changeStatusForm = res;
      if (res.rolesId && res.rolesId.length > 0) {
      this.workvalue = res.rolesId;
    }
      this.getallattachment();
      console.log("form data", res)
    })
  }

  openImagePopup(e:any){
  //  debugger
  //   this.popupImageUrl = e;
  //   this.isshowPopupVisible = true;
  if(e == null || e == undefined || e == ''){
return;
  }
  console.log(environment.apiRoot + "/"+ e)
  window.open(environment.apiRoot + "/"+ e, '_blank')
  }
  onFormSubmit(e:any) {
    debugger
    if(this.status_id) {
      let rolesId: any[] = [];

      this.roleDataSource?.__rawData?.forEach((element: any) => {
        rolesId.push(element?.id);
      });

      //this.changeStatusForm.rolesId = rolesId;
       this.changeStatusForm.rolesId = this.workvalue || [];
      this.publicSetting.update('ChangeEmployeeStatus' , this.changeStatusForm).subscribe((res:any)=>{
        this.router.navigate(['hr/ChangeEmployeeStatus'])
        this.NotifyService.notifyfun('edit')
      })
    }
  }
  // backToMainPage() {
  //   this.location.back();
  // }

  makeAsyncRoles() {
    return new CustomStore({
      loadMode: 'raw',
      key: 'id',
      load: () => {
        return (this.rolelist)
      }
    });
  }
    getAllJobTitledDropDown() {
    this.gt.getdropdowndata("JobTitle").subscribe((res: []) => {
      this.jobTitleDropDown = res
    })
  }  getAllAccountsDropDown() {
    this.gt.getdropdowndata('GeneralTypesWithAccountsDropDowns', 'AllAccountOpenEntryLastBasedOnTypeDropDown?accountType=101').subscribe((res: []) => {
      this.accountDropDown = res
    })
  }  getAllbankDropDown() {
    this.gt.getdropdowndata("Bank").subscribe((res: []) => {
      this.bankDropDown = res
    })
  }  getAlldepartmentDropDown() {
    this.gt.getdropdowndata("Department").subscribe((res: []) => {
      this.departmentDropDown = res
    })
  }  getUserDroDown() {
    this.loading = true;
    this.gt.getdropdowndata("User").subscribe(
      (res: {}[]) => {
        this.UserDropDown = res;
        //console.log(this.UserDropDown);  // Check if the data is being assigned
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching user data:', error);
        this.loading = false;
      }
    );
  }  getAllmanagementDropDown() {
    this.gt.getdropdowndata("Management").subscribe((res: []) => {
      this.managementDropDown = res
    })
  }getbranchdropdown(){
  this.gt.getdropdowndata('Branch').subscribe((res: []) => {
    this.branchesdropdown = res
  })
}

  getEmployeeAttachmentMenu() {
    this.gt.getdropdowndata('EmployeeAttachmentTypes').subscribe((res: any) => {
      this.AttacmentMenu = res;
    })
  }

}
